import React from 'react';

// Where the lead came from. Shown on every new transaction form.
export const SOURCE_OPTIONS = [
  'Friend',
  'Family',
  'Client Referral',
  'Personal Referral',
  'Agent Referral',
  'Open House',
  'Circle Prospecting',
  'Community Farming',
  'YouTube',
  'Cinc',
  'Meta',
  'Other',
];

// Dropdown for the lead source. Picking "Other" shows a box to type the source.
// Uses the form's own handleChange, so it saves as formData.source and formData.sourceOther.
export default function SourceSelect({ formData, onChange, styles = {} }) {
  const group = styles.inputGroup || styles.formGroup || {};
  const label = styles.label || {};
  const input = styles.input || {};

  return (
    <div style={group}>
      <label style={label} htmlFor="source-select">Lead Source</label>
      <select id="source-select" name="source" value={formData.source || ''} onChange={onChange} style={input}>
        <option value="">Choose a source</option>
        {SOURCE_OPTIONS.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
      {formData.source === 'Other' && (
        <input
          type="text"
          name="sourceOther"
          value={formData.sourceOther || ''}
          onChange={onChange}
          placeholder="Type the source"
          style={{ ...input, marginTop: 8 }}
        />
      )}
    </div>
  );
}
